import { useRenderProps } from '../services/renderPropsProvider';
import styles from './index.module.scss';

const DownloadSummarySlot = ({ acceptanceId, houseId }) => {
  const { renderActions } = useRenderProps();

  return typeof renderActions === 'function'
    ? renderActions({ acceptanceId, houseId, className: styles.root })
    : null;
};

export default DownloadSummarySlot;
